export const getExpMonthList = () => {
  const response = {
    data: [
      { value: "", label: "Month(MM)" },
      { value: "2", label: "02" },
      { value: "3", label: "03" },
      { value: "4", label: "04" },
      { value: "5", label: "05" },
      { value: "6", label: "06" },
      { value: "7", label: "07" },
      { value: "8", label: "08" },
      { value: "9", label: "09" },
      { value: "10", label: "10" },
      { value: "11", label: "11" },
      { value: "12", label: "12" },
    ],
  };
  return response;
};
export const getExpYearList = () => {
  const response = {
    data: [
      { value: "", label: "Year" },
      { value: "2022", label: "2022" },
      { value: "2023", label: "2023" },
      { value: "2024", label: "2024" },
      { value: "2025", label: "2025" },
      { value: "2026", label: "2026" },
      { value: "2027", label: "2027" },
      { value: "2028", label: "2028" },
      { value: "2029", label: "2029" },
      { value: "2030", label: "2030" },
      { value: "2031", label: "2031" },
      { value: "2032", label: "2032" },
    ],
  };
  return response;
};
export const getListOfStates = () => {
  const response = {
    data: [
      { value: "", label: "Select State" },
      { value: "AL", label: "Alabama" },
      { value: "AK", label: "Alaska" },
      { value: "AZ", label: "Arizona" },
      { value: "AR", label: "Arkansas" },
      { value: "CA", label: "California" },
      { value: "CO", label: "Colorado" },
      { value: "CT", label: "Connecticut" },
      { value: "DE", label: "Delaware" },
      { value: "FL", label: "Florida" },
      { value: "GA", label: "Georgia" },
      { value: "HI", label: "Hawaii" },
      { value: "ID", label: "Idaho" },
      { value: "IL", label: "Illinois" },
      { value: "IN", label: "Indiana" },
      { value: "IA", label: "Iowa" },
      { value: "KS", label: "Kansas" },
      { value: "KY", label: "Kentucky" },
      { value: "LA", label: "Louisiana" },
      { value: "ME", label: "Maine" },
      { value: "MD", label: "Maryland" },
      { value: "MA", label: "Massachusetts" },
      { value: "MI", label: "Michigan" },
      { value: "MN", label: "Minnesota" },
      { value: "MS", label: "Mississippi" },
      { value: "MO", label: "Missouri" },
      { value: "MT", label: "Montana" },
      { value: "NE", label: "Nebraska" },
      { value: "NV", label: "Nevada" },
      { value: "NH", label: "New Hampshire" },
      { value: "NJ", label: "New Jersey" },
      { value: "NM", label: "New Mexico" },
      { value: "NY", label: "New York" },
      { value: "NC", label: "North Carolina" },
      { value: "ND", label: "North Dakota" },
      { value: "OH", label: "Ohio" },
      { value: "OK", label: "Oklahoma" },
      { value: "OR", label: "Oregon" },
      { value: "PA", label: "Pennsylvania" },
      { value: "RI", label: "Rhode Island" },
      { value: "SC", label: "South Carolina" },
      { value: "SD", label: "South Dakota" },
      { value: "TN", label: "Tennessee" },
      { value: "TX", label: "Texas" },
      { value: "UT", label: "Utah" },
      { value: "VT", label: "Vermont" },
      { value: "VA", label: "Virginia" },
      { value: "WA", label: "Washington" },
      { value: "WV", label: "West Virginia" },
      { value: "WI", label: "Wisconsin" },
      { value: "WY", label: "Wyoming" },
      { value: "DC", label: "Washington DC" },
      { value: "PR", label: "Puerto Rico" },
      { value: "GU", label: "Guam" },
      { value: "AS", label: "American Samoa" },
      { value: "VI", label: "U.S. Virgin Islands" },
      { value: "MP", label: "Northern Mariana Islands" },
    ],
  };
  return response;
};
const padTo2Digits = (num: { toString: () => string }) => {
  return num.toString().padStart(2, "0");
};

export const formatDate = (date: any) => {
  var modifiedDate = new Date(date);
  var finalDate =
    modifiedDate.toLocaleString("default", { month: "short" }) +
    " " +
    padTo2Digits(modifiedDate.getDate()) +
    "," +
    modifiedDate.getFullYear();
  return finalDate;
};
export const formatDateTime = (date: any) => {
  return (
    [date.getFullYear(), padTo2Digits(date.getUTCMonth() + 1), padTo2Digits(date.getUTCDate())].join("-") +
    " " +
    [padTo2Digits(date.getUTCHours()), padTo2Digits(date.getUTCMinutes()), padTo2Digits(date.getUTCSeconds())].join(":")
  );
};
export const getEventTypeAndTopic = () => {
  const response = {
    data: [
      { name: "user", eventType: "user", eventSubType: "login", topicName: "user" },
      { name: "email", eventType: "", eventSubType: "Year", topicName: "" },
    ],
  };
  return response;
};
